import { Api } from '../../types/apiSpec';
import { filter } from '../functional';

export const filterItemByType =
  (type: Api.TrainingType) =>
  <T extends { type: Api.TrainingType }>(item: T) =>
    item.type === type;

export const filterByType = (type: Api.TrainingType) => filter(filterItemByType(type));
